export interface TaxRateLike {
  id?: number | string | null;
  name?: string | null;
  code?: string | null;
  rate?: number | string | null;
  is_default?: boolean | null;
  report_category?: string | null;
}

export const STANDARD_VAT_RATE = 15;

export function parseTaxRateValue(rate: unknown): number {
  const parsed = typeof rate === 'string' ? parseFloat(rate) : Number(rate);
  return Number.isFinite(parsed) ? parsed : 0;
}

export function hasVatRegistrationNumber(value: string | null | undefined): boolean {
  return typeof value === 'string' && value.trim().length > 0;
}

function isZeroRatedLike(rate: TaxRateLike): boolean {
  if (parseTaxRateValue(rate.rate) !== 0) {
    return false;
  }

  const descriptor = `${rate.name || ''} ${rate.code || ''} ${rate.report_category || ''}`.toLowerCase();
  return /zero|zero-rated|exempt|no vat/.test(descriptor);
}

export function getPreferredDefaultTaxRate<T extends TaxRateLike>(
  taxRates: T[] | null | undefined,
): T | undefined {
  const normalizedRates = Array.isArray(taxRates) ? taxRates : [];

  return normalizedRates.find((rate) => Boolean(rate.is_default))
    || normalizedRates.find((rate) => isZeroRatedLike(rate))
    || normalizedRates.find((rate) => parseTaxRateValue(rate.rate) === 0)
    || normalizedRates.find((rate) => parseTaxRateValue(rate.rate) === STANDARD_VAT_RATE)
    || normalizedRates[0];
}

export function getPreferredDefaultTaxRateValue(taxRates: TaxRateLike[] | null | undefined): number {
  return parseTaxRateValue(getPreferredDefaultTaxRate(taxRates)?.rate);
}
